import React from "react";
import YTLoader from './../../../../js/utils/YTLoader';
class PlayerYoutube {
  constructor(id, container) {
    this.id = this._parseID(id);
    this.container = container;
    this.loaded = false;
    this.waitingForPlay = false;
    YTLoader.load(this._onLoaded.bind(this))
  }

  get imageURL() {
    return Promise.resolve('https://i.ytimg.com/vi/' + this.id + '/hqdefault.jpg')
  }

  play() {
    this.waitingForPlay = true;
    if (this.loaded) {
      this.player = new YT.Player(this.container, {
        height: '100%',
        width: '100%',
        videoId: this.id,
        autoplay: 1,
        rel: 0,
        playerVars: {
          rel: '0',
        },
        host:  'https://www.youtube-nocookie.com',
        events: {
          'onReady': this._onPlayerReadyYoutube.bind(this),
          'onStateChange': this._onPlayerStateChangeYoutube.bind(this)
        }
      })
      this.waitingForPlay = false;
    } else {
      this.waitingForPlay = true;
    }

  }

  stop() {
    try{
      if (this.player)
        this.player.stopVideo()
    }catch (e) {

    }

  }

  set onPlayCallback(fn) {
    if (typeof fn === "function")
      this._onPlay = fn;
  }

  set onStopCallback(fn) {
    if (typeof fn === "function")
      this._onStop = fn;
  }

  _onPlay() {

  }
  _onStop() {

  }

  _onPlayerStateChangeYoutube(event) {
    if ((event.data === YT.PlayerState.PLAYING)) {
      this._onPlay();
    }
    if ((event.data === YT.PlayerState.ENDED)) {
      this._onStop();
    }
  }

  _onPlayerReadyYoutube(event) {
    event.target.playVideo()
  }

  _onLoaded() {
    this.loaded = true;
    if (this.waitingForPlay)
      this.play();
  }

  //
  // UTILS
  //
  _parseID(id) {
    if (id.indexOf('/') === -1)
      return id;

    let exp = new RegExp('(?:youtube(?:-nocookie)?\.com/(?:[^/]+/.+/|(?:v|e(?:mbed)?)/|.*[?&]v=)|youtu\.be/)([^"&?/ ]{11})', 'i')
    let match = id.match(exp);
    if (match) {
      return match[1];
    }
    return id;
  }
}

export default (PlayerYoutube)


// WEBPACK FOOTER //
// ./vendor/bbs/crt/src/resources/views/components/player/players/PlayerYoutube.js